<template>
  <div v-if="isAdmin" class="panel-admin-body">
    <div class="title">{{ title }}</div>
    <div class="container company-list">
      <div class="unique-codes-section border-bottom mt-3">
        <div class="d-flex w-100 flex-column">
          <div class="row">
            <div class="col-lg-2 col-md-12 col-sm-12">
              <div class="w-100 text-center">&nbsp;</div>
              <div class="form-group">
                <label for="filterByClient" class="mr-1 w-100">Client</label>
                <select id="client" name="client" class="custom-select required" v-model="ai_client_search_id" @change="filterClientNameOptions">
                  <option
                      v-for="(client_option, idxClientOptions) in this.client_options"
                      v-bind:value="client_option.value"
                      v-bind:key="idxClientOptions"
                  >
                      {{ client_option.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-2 col-md-12 col-sm-12">
              <div class="w-100 text-center">&nbsp;</div>
              <div class="form-group">
                <label for="filterBySection" class="mr-1 w-100">Module</label>
                <select id="section" name="section" class="custom-select required" v-model="section">
                  <option
                      v-for="(section_option, idxSectionOptions) in this.section_options"
                      v-bind:value="section_option.value"
                      v-bind:key="idxSectionOptions"
                  >
                      {{ section_option.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-2 col-md-12 col-sm-12">
              <div class="w-100 text-center">&nbsp;</div>
              <div class="form-group">
                <label for="aiType" class="mr-1 w-100">AI Type</label>
                <select id="aiType" name="aiType" class="custom-select required" v-model="aiType">
                  <option
                    v-for="(ai_type_option, idxAITypeOptions) in this.ai_type_options"
                    v-bind:value="ai_type_option.value"
                    v-bind:key="idxAITypeOptions"
                  >
                    {{ ai_type_option.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-2 col-md-12 col-sm-12">
              <div class="w-100 text-center">&nbsp;</div>
              <div class="form-group">
                <label for="status" class="mr-1">Status</label>
                <select id="status" name="status" class="custom-select required" v-model="status">
                  <option v-for="(status_option, idxStatusOptions) in this.status_options" v-bind:value="status_option.value" v-bind:key="idxStatusOptions">
                    {{ status_option.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <filter-buttons @reset="reset" @filterData="filterData" :is-data-filtering="isDataFiltering" :is-filter-resetting="executeReset"/>
        </div>
      </div>
      <div class="button-container pb-1">
        <div class="button-left"></div>
        <div class="button-right"></div>
      </div>
      <table :id="table.id" :class="table.class" cellspacing="0" width="100%">
        <thead></thead>
        <tbody></tbody>
      </table>
    </div>
  </div>
  <div v-else class="panel-admin-body no-permission-list">You do not have permission to view this page</div>
</template>

<script>
import $ from "jquery";
import Vue from "vue";

import moment from "moment-timezone";
Vue.prototype.moment = moment;

import AdminMixins from "../../mixins/AdminMixins.vue";
import DataTableMixins from "../../mixins/DataTableMixins.vue";
import AdminService from "../../services/admin.service";
import AIService from "../../services/ai.service";
import FilterButtons from "../../components/filter/FilterButtons.vue";
import FilterMixins from "../../mixins/FilterMixins.vue";

export default {
  name: "AIAuditLog",
  mixins: [AdminMixins, DataTableMixins, FilterMixins],
  components: {FilterButtons},
  data() {
    return {
      importCompanyImportFile: "",
      title: "AI Audit Log",
      table: {
        id: "ai-audit-table",
        columns: AIService.getAIAuditTableColumnData(),
        configuration: {
          searching: true,
          responsive: false,
          dom: 'B<"top"if>rt<"bottom"lp><"clear">',
          paging: true,
          select: true,
          destroy: true,
          info: true,
          ordering: true,
          keys: true,
          bSort: false,
          bSortable: true,
          processing: true,
          columnDefs: [
              {
              targets: 0,       // index of the select-all column
              orderable: false  // disable sorting
              }
          ],
          pageLength: 50,  
        }
      },
      aiRecommendationCacheIdsToDelete: [],
      needsList: [],
      originalList: [],
      client_options: [],
      section_options: [],
      ai_client_search_id: 0,
      section: "",
      status_options: [
        { name: "Select Status", value: "" },
        { name: "Success", value: "success" },
        { name: "Failed", value: "failed" },
        { name: "Gemini Error", value: "gemini_error" },
        { name: "Other", value: "other" }
      ],
      status: "",
      ai_type_options: [],
      aiType: "",
    };
  },
  methods: {
    async getTableData() {
      this.$root.processServerRequest("Loading table data");
      AIService.getAIAuditLog(this.getTableDataCallback, this);
    },
    getTableDataCallback(response) {
      this.$root.processServerResponse();
      this.originalList = response.data.data;
      this.table.data = this.originalList;
      this.client_options = AIService.buildClientOptionList(this.originalList);
      this.section_options = AIService.buildAISectionOptionList(this.originalList);
      this.ai_type_options = AIService.buildAITypeOptionList(this.originalList);
      this.setupTable();
      // this.setupRowClick();
      
    },
    setupRowClick() {
      const vm = this;
      const th = $('#ai-audit-table thead').find("th").eq(0);
      th.html('<input type="checkbox" id="select-all" class="text-left ml-0 align-text-bottom"/>');
      if( this.table.dataTable.click == undefined)  {

        this.table.dataTable.on("click", 'input[type="checkbox"]', function(e, dt, type, indexes) {
            var $row = $(this).closest("tr");
            var data = vm.table.dataTable.row($row).data();
            if (!$.isEmptyObject(data)) {
                if (e.target.checked) {
                    if (!vm.aiRecommendationCacheIdsToDelete.includes(data.aiRecommendationCacheId)){
                        vm.aiRecommendationCacheIdsToDelete.push(data.aiRecommendationCacheId);
                    }
                } else {
                    var match = vm.aiRecommendationCacheIdsToDelete.find(x => x === data.aiRecommendationCacheId);
                    if (typeof match !== "undefined") {
                        vm.aiRecommendationCacheIdsToDelete.splice($.inArray(match, vm.aiRecommendationCacheIdsToDelete), 1);
                    }
                    $row.removeClass("selected");
                    e.stopPropagation();
                }
            }
        });

        $('#select-all').on('click', function(){
          if ($(this).is( ":checked" )) {
              vm.selectAll();
              // Disable ordering for all columns
              const table = $('#ai-audit-table').DataTable();
              table.columns().every(function () {
                  this.orderable(false);
              });
          } else {
              vm.deselectAll();
              // Re-enable ordering if needed
              const table = $('#ai-audit-table').DataTable();
              table.columns().every(function () {
                  this.orderable(false);
              });
          }
        });
      }
    },
    selectAll: function(){
      let vm = this;
      vm.table.dataTable.rows({ page: 'current' }).every(function(rowIdx){
          var $row = $( this.node() );
          let data = vm.table.dataTable.row($row).data();
          vm.addToDownloadSets(data);
          $row.find('input[name="aiRecommendationCacheIdToDelete"]').prop('checked', true)
      });
    },
    addToDownloadSets: function(data){
      if (!$.isEmptyObject(data)) {
          this.aiRecommendationCacheIdsToDelete.push(data.aiRecommendationCacheId);
      }
    },
    deselectAll: function(){
      this.aiRecommendationCacheIdsToDelete = [];
      // uncheck all rows in table
      let vm = this;
      // deselect all checkboxes in DOM at once
      $(vm.table.dataTable.rows().nodes()).find('input[name="aiRecommendationCacheIdToDelete"]').prop('checked', false);
    },
    async deleteAIRecommendationsCacheList(result) {
      AIService.deleteAIRecommendationsCacheList(this.aiRecommendationCacheIdsToDelete,this.deleteRecommendationsCacheDataListCallback,this);
    },
    deleteRecommendationsCacheDataListCallback(response) {
        this.$root.processServerResponse();
        let statusCode = response.data.statusCode;
        if (statusCode == 200) {
            AdminService.displaySuccessMessage({ text: response.data.message });
            this.aiRecommendationCacheIdsToDelete = [];
            this.ai_client_search_id = 0;
            this.getTableData();
        } else {
            AdminService.displayErrorMessage({ text: response.data.message });
        }
    },
    filterData: async function(){
      await this.preFilter();
      let vm = this;
      setTimeout(async () => {
        if(this.ai_client_search_id != 0){
          this.filteredList =  AIService.getAICacheResultsByClient(this.filteredList, this.ai_client_search_id);
        }
        if(this.section != "") {
          this.filteredList =  AIService.getAIAuditLogsBySectorName(this.filteredList, this.section);
        }
        if(this.aiType != "") {
          this.filteredList =  AIService.getAIAuditLogsByAiTypeName(this.filteredList, this.aiType);
        }
        if (this.status != "") {
          this.filteredList = this.filteredList.filter(input => {
            const statusCode = Number(input.statusCode);
            if (this.status === "success") {
              return statusCode === 200;
            }
            if (this.status === "failed") {
              return statusCode === 400 || statusCode === 500;
            }
            if (this.status === "gemini_error") {
              return statusCode === 503 || statusCode === 429;
            }
            if (this.status === "other") {
              return statusCode !== 200 && statusCode !== 400 && statusCode !== 500 && statusCode !== 503 && statusCode !== 429;
            }
            return true;
          });
        }
        vm.table.data = vm.filteredList;
        vm.setupTable();
        vm.postFilter();
      }, 200);
    },
    reset(){
      this.table.data = this.originalList;
      this.client_options = AIService.buildClientOptionList(this.originalList);
      this.ai_client_search_id = 0;
      this.section = "";
      this.status = "";
      this.aiType = "";
      this.table.configuration.order = this.tableSortBy;
      this.setupTable();
    },
  },
  computed: {
    deleteButtonEnabled: function(){
        return this.aiRecommendationCacheIdsToDelete.length > 0;
    },
  },
  created() {
    if (this.isAdmin) {
      this.getTableData();
      this.table.configuration.order = [[0, "desc"]];
    }
  },
  props: {},
  mounted() {}
};
</script>
